// Navbar.jsx
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import schoolLogo from "./school_icon-removebg-preview.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  const handleLinkClick = () => {
    setOpenDropdown(null);
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`} ref={navbarRef}>
      <Link to="/" className="navbar-logo" onClick={handleLinkClick}>
        <img src={schoolLogo} alt="School Logo" />
        <div className="school-namee">
          <span>OXFORD CONVENT ENGLISH MEDIUM SCHOOL</span>
          <span className="titlee">KHAJURI</span>
        </div>
      </Link>

      <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? '✕' : '☰'}
      </button>

      <ul className={`navbar-links ${menuOpen ? "active" : ""}`}>
        <li>
          <Link to="/" onClick={handleLinkClick}>Home</Link>
        </li>

        <li className="dropdown">
          <span onClick={() => toggleDropdown(1)}>About Us ▾</span>
          <ul className={`dropdown-menu ${openDropdown === 1 ? "show" : ""}`}>
            <li><Link to="/about-school" onClick={handleLinkClick}>About School</Link></li>
            <li><Link to="/mission-vision" onClick={handleLinkClick}>Mission and Vision</Link></li>
            <li><Link to="/principal-message" onClick={handleLinkClick}>Principal's Message</Link></li>
            <li><Link to="/contact-us" onClick={handleLinkClick}>Contact Us</Link></li>
          </ul>
        </li>

        <li className="dropdown">
          <span onClick={() => toggleDropdown(2)}>Academic ▾</span>
          <ul className={`dropdown-menu ${openDropdown === 2 ? "show" : ""}`}>
            <li><Link to="/aims-objective" onClick={handleLinkClick}>Aims and Objectives</Link></li>
            <li><Link to="/school-hours" onClick={handleLinkClick}>School Hours</Link></li>
            <li><Link to="/school-section" onClick={handleLinkClick}>School Section</Link></li>
            <li><Link to="/why-this-school" onClick={handleLinkClick}>Why This School</Link></li>
          </ul>
        </li>

        <li className="dropdown">
          <span onClick={() => toggleDropdown(3)}>Admission ▾</span>
          <ul className={`dropdown-menu ${openDropdown === 3 ? "show" : ""}`}>
            <li><Link to="/new-application-form" onClick={handleLinkClick}>New Application Form</Link></li>
            <li><Link to="/fee-structure" onClick={handleLinkClick}>Fee Structure</Link></li>
          </ul>
        </li>

        <li className="dropdown">
          <span onClick={() => toggleDropdown(4)}>Gallery ▾</span>
          <ul className={`dropdown-menu ${openDropdown === 4 ? "show" : ""}`}>
            <li><Link to="/photos" onClick={handleLinkClick}>Photos</Link></li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
